import { Routes, Route } from 'react-router-dom'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import Home from './pages/Home/Home'
import Products from './pages/Products/Products'
import Solutions from './pages/Solutions/Solutions'
import Cases from './pages/Cases/Cases'
import News from './pages/News/News'
import About from './pages/About/About'
import ContactProvider from './providers/ContactProvider'
import './utils/submissionViewer' // 加载表单查看工具

function App() {
  return (
    <ContactProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/news" element={<News />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ContactProvider>
  )
}

export default App 